<div class="campaign-start-container">
  <ngx-app-bar
    class="w-100"
    [title]="'دریافت جایزه گنج'"
    [rightButton]="{
      icon: 'arrow-right',
      style: 'neutral-link',
      mode: 'icon-only',
      size: 'medium',
    }"
    (onRightButtonClick)="onBackHandler()"
  />

  <div class="campaign-start-content">
    <img src="wealth-assets/images/treasure-hunt-2.svg" />
    <p class="campaign-start-title">ظرفیت دریافت جایزه تکمیل شده!</p>
    <p class="campaign-start-description">برای جایزه‌های بعدی گوش به زنگ باشید.</p>
  </div>
  <div class="campaign-start-buttons">
    <ngx-button
      [buttonId]="'CAMPAIGN_CAPACITY_FULL'"
      [style]="'fill'"
      [fullWidth]="true"
      (clickHandler)="onBackHandler()"
    >
      متوجه شدم
    </ngx-button>
  </div>
</div>
